import { EApiSortType } from '@/api/apiConstants'

const FILTER_TAGS_QUERY_KEY = 'filter-tags' as const
const filterTagQueryKey = { ...useQueryKeyFactory(FILTER_TAGS_QUERY_KEY) }

const MARKETING_TAGS_QUERY_KEY = 'marketing-tags' as const
const marketingTagQueryKey = { ...useQueryKeyFactory(MARKETING_TAGS_QUERY_KEY) }

const DIETARY_TAGS_QUERY_KEY = 'dietary-tags' as const
const dietaryTagQueryKey = { ...useQueryKeyFactory(DIETARY_TAGS_QUERY_KEY) }

const groupPrefixFilter = createApiRoute(ApiModule.DIETARY, ApiDataModel.FILTER_TAGS)
const groupPrefixMarketing = createApiRoute(ApiModule.DIETARY, ApiDataModel.MARKETING_TAGS)
const groupPrefixDietary = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIETARY_TAGS)

export const apiDietTags = {
	/**
	 * Filters
	 */
	fetchDietFilterTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<IApiResponseModel<IDietFilterTagModel[]>> => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IDietFilterTag[]>(`${groupPrefixFilter}`, {
				method: 'GET',
				...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
			})

			return { data: data.map(d => DietFilterTag(d)), meta }
		}

		const config = () => ({
			queryKey: filterTagQueryKey.list({ page, perPage, model_type }),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IApiResponseModel<IDietFilterTagModel[]>>(config)
	},
	createFilterTag: async (payload: IDietTagCreatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixFilter}`, {
			method: 'POST',
			body: payload,
		})

		useQueryClientService().invalidateQueries(filterTagQueryKey.lists())

		return DietFilterTag(data)
	},
	updateFilterTag: async (tagId: number, payload: IDietTagUpdatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixFilter}/${tagId}`, {
			method: 'PUT',
			body: payload,
		})

		useQueryClientService().invalidateQueries(filterTagQueryKey.lists())

		return DietFilterTag(data)
	},
	deleteFilterTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixFilter}/${id}`, { method: 'DELETE' })

		useQueryClientService().invalidateQueries(filterTagQueryKey.lists())
	},

	/**
	 * Marketing
	 */
	fetchDietMarketingTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<IApiResponseModel<IDietMarketingTagModel[]>> => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IDietMarketingTag[]>(`${groupPrefixMarketing}`, {
				method: 'GET',
				...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
			})
			return { data: data.map(d => DietMarketingTag(d)), meta }
		}

		const config = () => ({
			queryKey: marketingTagQueryKey.list({ page, perPage, model_type }),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IApiResponseModel<IDietMarketingTagModel[]>>(config)
	},
	createMarketingTag: async (payload: IDietTagCreatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixMarketing}`, {
			method: 'POST',
			body: payload,
		})

		useQueryClientService().invalidateQueries(marketingTagQueryKey.lists())

		return DietMarketingTag(data)
	},
	updateMarketingTag: async (tagId: number, payload: IDietTagUpdatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixMarketing}/${tagId}`, {
			method: 'PUT',
			body: payload,
		})

		useQueryClientService().invalidateQueries(marketingTagQueryKey.lists())

		return DietMarketingTag(data)
	},
	deleteMarketingTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixMarketing}/${id}`, { method: 'DELETE' })

		useQueryClientService().invalidateQueries(marketingTagQueryKey.lists())
	},

	/**
	 * Dietary
	 */
	fetchDietaryTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<IApiResponseModel<IDietDietaryTagModel[]>> => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IDietDietaryTag[]>(`${groupPrefixDietary}`, {
				method: 'GET',
				...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
			})
			return { data: data.map(d => DietDietaryTag(d)), meta }
		}

		const config = () => ({
			queryKey: dietaryTagQueryKey.list({ page, perPage, model_type }),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IApiResponseModel<IDietDietaryTagModel[]>>(config)
	},
	createDietaryTag: async (payload: IDietTagCreatePayload): Promise<IDietDietaryTagModel> => {
		const { data } = await apiCommon<IDietDietaryTag>(`${groupPrefixDietary}`, {
			method: 'POST',
			body: payload,
		})

		useQueryClientService().invalidateQueries(dietaryTagQueryKey.lists())

		return DietDietaryTag(data)
	},
	updateDietaryTag: async (tagId: number, payload: IDietTagUpdatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixDietary}/${tagId}`, {
			method: 'PUT',
			body: payload,
		})

		useQueryClientService().invalidateQueries(dietaryTagQueryKey.lists())

		return DietMarketingTag(data)
	},
	deleteDietaryTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixDietary}/${id}`, { method: 'DELETE' })

		useQueryClientService().invalidateQueries(dietaryTagQueryKey.lists())
	},
}
